import { StateCreator } from 'zustand';

type DrawerContent = 'executions' | 'node_form' | null;

type State = {
  openItem: string[];
  drawerOpen: boolean;
  leftDrawerWidth: number;
  rightDrawerOpen: boolean;
  rightDrawerWidth: number;
  rightDrawerContent: DrawerContent;
  selectedExecutionId: string | null;
  toolbarHeight: number;
};

type Actions = {
  setActiveItem: (item: string[]) => void;
  toggleDrawer: () => void;
  setDrawerOpen: (open: boolean) => void;
  setToolbarHeight: (toolbarHeight: number) => void;
  toggleRightDrawer: () => void;
  setRightDrawerOpen: (open: boolean) => void;
  setLeftDrawerWidth: (width: number) => void;
  setRightDrawerWidth: (width: number) => void;
  setRightDrawerContent: (content: string | null) => void;
  setSelectedExecutionId: (id: string | null) => void;
};

export type MenuSlice = State & Actions;

export const createMenuSlice: StateCreator<MenuSlice, [['zustand/immer', never]], [], MenuSlice> = (set) => ({
  openItem: ['/'],
  drawerOpen: true,
  rightDrawerOpen: false,
  rightDrawerWidth: 0,
  leftDrawerWidth: 220,
  rightDrawerContent: null,
  selectedExecutionId: null,
  toolbarHeight: 44,
  setActiveItem: (item) => set(() => ({ openItem: item })),
  toggleDrawer: () => set((state) => ({ drawerOpen: !state.drawerOpen })),
  setDrawerOpen: (open) => set(() => ({ drawerOpen: open })),
  toggleRightDrawer: () => set((state) => ({ rightDrawerOpen: !state.rightDrawerOpen })),
  setToolbarHeight: (toolbarHeight) => set(() => ({ toolbarHeight })),
  setRightDrawerOpen: (open) => set(() => ({ rightDrawerOpen: open })),
  setLeftDrawerWidth: (width) => set(() => ({ leftDrawerWidth: width })),
  setRightDrawerWidth: (width) => set(() => ({ rightDrawerWidth: width })),
  setRightDrawerContent: (content) => set(() => ({ rightDrawerContent: content })),
  setSelectedExecutionId: (id) => set(() => ({ selectedExecutionId: id })),
});
